const FormData = require('form-data');
const stringify = require('json-stringify-safe');
import algoliasearch from 'algoliasearch/lite';
// import store from '../store'
import { toastController } from '@ionic/vue';

const register = {
  namespaced: true,
  registerActive: null,
  state: {
    registers: {},
    observers: {
      counts: { snapshots: [] }
    },
    mongodb: {},
    loading: {},
    counters: {},
    lastAlgoliaReqParams: {},
  },
  mutations: {
    setRegister(state, { register, data, unshift = false }) {
      if (!state.registers[register]) { 
        // store.$set(state.registers, [register], [])
        state.registers[register] = []
      }
      const ix = state.registers[register].findIndex(x => x.id == data.id)
      if (ix > -1) {
        // store.$set(state.registers[register], [ix], data)
        state.registers[register][ix] = data
      } else if (unshift) {
        state.registers[register].unshift(data)
      } else {
        state.registers[register].push(data)
      }
    },
    setRegisterActive(state, {register}) {
      state.registerActive = register
    },
    removeRegister(state, { register, data }) {
      const ix = state.registers[register].findIndex(x => x.id == data.id)
      if (ix > -1) {
        state.registers[register].splice(ix, 1)
      }
    },
    resetRegister(state, register) { state.registers[register] = []},
    // resetRegisters(state) { store.$set(state, 'registers', {}) },
    resetRegisters(state) {state.registers = {}},

    setCounter(state, { collection, count }) {
      // store.$set(state.counters, collection, count)
    },
    resetCounters(state) { state.counters = {} },
  },
  actions: {
    getCustomer({ rootState }, collection) {
      if (['users', 'notifications', 'customers', '_configs'].includes(collection) || typeof collection === 'undefined') return ''
      
      if (rootState.collectionStructure || collection === 'e') {
        return rootState.companySelected.groupCompany;
      }

      return null
    },

    // GPEmpresa
    getGpEmpresa({ rootState }, collection) {
      let gpEmpresa = ''
      if (
        collection === 'e' 
        || 
        (
          rootState.collectionStructure 
          && Object.prototype.hasOwnProperty.call(rootState.collectionStructure, collection)
        )
      ) { 
        if (rootState.collectionStructure[collection] && rootState.collectionStructure[collection]['X2_GRUPO']) {
          gpEmpresa = rootState.collectionStructure[collection]['X2_GRUPO'] + '0'
        } else { 
          gpEmpresa = rootState.companySelected.M0_CODIGO + '0'
        }
      }
      
      return gpEmpresa
    },

    // Filial
    getFilial({ rootState }, collection) {
      let filial = ''
      if (collection === 'e') {
        // Força Exclusivo
        filial = rootState.companySelected.M0_CODFIL
      } else if (collection != '_configs' && rootState.collectionStructure  && Object.prototype.hasOwnProperty.call(rootState.collectionStructure, collection)) {
        if (rootState.companySelected.M0_NOME == 'ORE') {
          // TODO Após compilação retirar legado
          rootState.companySelected.M0_LEIAUTE = 'EEFF'
          if (collection == 'SA1') rootState.companySelected.M0_LEIAUTE = 'FFFF'
        }
        
        const X2_MODOEMP = rootState.collectionStructure[collection]['X2_MODOEMP']
        const X2_MODOUN = rootState.collectionStructure[collection]['X2_MODOUN']
        const X2_MODO = rootState.collectionStructure[collection]['X2_MODO']

        // Compartilhado
        if (
          X2_MODOEMP == 'C'
          && X2_MODOUN == 'C'
          && X2_MODO == 'C'
        ) {
          filial = ' '.repeat(rootState.companySelected.M0_SIZEFIL)
        }

        // Exclusivo
        else if (
          X2_MODOEMP == 'E'
          && X2_MODOUN == 'E'
          && X2_MODO == 'E'
        ) {
          filial = rootState.companySelected.M0_CODFIL
        }

        // Exclusivo/Compartilhado
        else {
          let leiaute = rootState.companySelected.M0_LEIAUTE || 'FF'
          leiaute = leiaute.split("")
          
          const leiaute_E = leiaute.filter(x => x == 'E')
          const leiaute_U = leiaute.filter(x => x == 'U')
          const leiaute_F = leiaute.filter(x => x == 'F')
          
          if (leiaute_E.length > 0) filial += (X2_MODOEMP == 'C') ? ' '.repeat(leiaute_E.length) : rootState.companySelected.M0_CODFIL.substr(0, leiaute_E.length)
          if (leiaute_U.length > 0) filial += (X2_MODOUN == 'C') ? ' '.repeat(leiaute_U.length) : rootState.companySelected.M0_CODFIL.substr(filial.length, leiaute_U.length)
          if (leiaute_F.length > 0) filial += (X2_MODO == 'C') ? ' '.repeat(leiaute_F.length) : rootState.companySelected.M0_CODFIL.substr(filial.length, leiaute_F.length)
          // console.info('collection => ', collection, 'x2 => ', rootState.collectionStructure[collection], 'leiaute =>', leiaute_E, leiaute_U, leiaute_F, 'filial => ', filial)
        }
      } 
      return filial
    },

    mountedFilters({ state, rootState }, { ref, filters, register, forceFilter = false, tenantId = null, userLogged = null }) {
      try {
        const user = userLogged || rootState.auth.user // Disponivel para Filtro
        const userRules = state.registers.userRules
        const rules = (user?.companies && user?.companies[tenantId]?.rules) ? userRules.filter(x => user?.companies[tenantId]?.rules.includes(x.id)) : []
        const registerOriginal = (register) ? register.replace('Filtered','') : register

        // DESABILITA FILTROS PARA SUPER ADMIN OU PAPEL ESTEJA LIBERADO
        if (
          !forceFilter && 
          (
            tenantId && (
              user?.superAdmin ||
              (user?.companies && user?.companies[tenantId]?.admin) || 
              ( 
                rules
                && rules.some(x => x.claims && x.claims[registerOriginal] && x.claims[registerOriginal].noFilters)
              )
            )
          )
        ) {
          return ref || []
        }

        let ret = []

        filters.forEach(el => {
          let { key, operator, value, expectedValue, when = true, allowEmpty = false } = el
          // console.info('FILTER =>', key, operator, value, expectedValue, when)

          if (typeof when === 'boolean' && !when) {
            return;
          } else if (typeof when == 'string' && when.includes('${')) {
            const whenEval = eval(when)
            if (typeof whenEval === 'string' && !eval(whenEval)) {
              return;
            } else if (typeof whenEval === 'boolean' && !whenEval) {
              return;
            }
          }

          // Validation
          if (
            !key
            || !operator
            || (typeof value != 'boolean' && !value && !allowEmpty)
            || (Array.isArray(value) && !value.length > 0)
          ) throw { error: 'Malformed Filter', filter: el, register }

          if (typeof value == 'string' && key.includes('${')) {
            key = eval(key)
          }

          if (typeof value == 'string' && value.includes('${')) {
            value = eval(value)
          }

          // Array
          if (value == undefined || value == 'undefined') { 
            value = ''
          }

          if (typeof value == 'string' && value.includes(',') && expectedValue && expectedValue === 'array') {
            value = value.split(",")
          } else if (typeof value == 'string' && value && expectedValue && expectedValue === 'array') { 
            value = [value]
          }

          // console.info('FORMATED FILTER =>', key, operator, value, user)
          if (!!key && (typeof value != 'boolean' && !value  && !allowEmpty)) {
            throw { error: 'Empty Filter', filter: el, register }
          } else if (ref) {
            ref = ref.where(key, operator, value)
          } else {
            ret.push({ key, operator, value })
          }
        })

        return (ref) ? ref : ret
      } catch (error) {
        console.error(error)
        return null
      }
    },

    // OBSERVER
    async prepareRef ({state, dispatch, rootState}, { tenantId, gpEmpresa, filial, collection, register, filters, filtersSaller, filtersClient , orderBy, limit = 30, forceFilter }) {
      const user = rootState.auth.user
      let ref = this.$db().collection(collection)

      if (filters) ref = await dispatch('mountedFilters', { ref, filters, register, forceFilter, tenantId })
      if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersClient), register, forceFilter, tenantId })
      else if (filtersSaller) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersSaller), register, forceFilter, tenantId })
      
      if (!ref) return state.loading[register] = false

      ref = ref.where('lifeControl.deletedAt', '==', null)
      if (filial) ref = ref.where('filial', '==', filial)
      if (gpEmpresa) ref = ref.where('gpEmpresa', '==', gpEmpresa.slice(0, -1))
      
      // ORDER BY
      let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
      for (const el of order) {
        if (el && typeof el == 'string') {
          ref = ref.orderBy(el)
        } else if (el && typeof el != 'string') {
          ref = ref.orderBy(el.key, el.mod)
        } else {
          ref = ref.orderBy(this.$db.FieldPath.documentId(), 'desc')
        }
      }

      // LIMIT
      ref = ref.limit(limit)

      return ref
    },
    async observer({ state, dispatch, rootState }, { collection, register, filters, disableIntFilters = false, details, orderBy, limit = 30, forceFilter = false, notUnshift}) {
      const user = rootState.auth.user
      const integration = (state.registers.integrations) ? state.registers.integrations.find(x => x.collection === collection) : null

      if (!state.registers[register]) { 
       state.registers[register] = [] 
      }
      if (!state.loading[register]) {
        state.loading[register] = true
      }

      // PREPARE ENVIROMENT
      const tenantId = await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') {
        throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
      }
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const filial = await dispatch('getFilial', collection)

      collection = tenantId ? `customers/${tenantId}/${collection}` : collection

      dispatch('count', { collection: 'searchAlgolian' })
      
      let ref = this.$db().collection(collection)

      // FILTERS
      if (filters) ref = await dispatch('mountedFilters', { ref, filters, register, forceFilter, tenantId, userLogged: user })
      if (integration && !disableIntFilters) {
        let { filtersSaller, filtersClient } = integration
        if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersClient), register, forceFilter, tenantId, userLogged: user })
        else if (filtersSaller) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersSaller), register, forceFilter, tenantId, userLogged: user })
      }

      if (!ref) return state.loading[register] = false
      
      ref = ref.where('lifeControl.deletedAt', '==', null)
      if (filial) ref = ref.where('filial', '==', filial)
      if (gpEmpresa) ref = ref.where('gpEmpresa', '==', gpEmpresa.slice(0, -1))
      
      // ORDER BY
      let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
      for (const el of order) {
        if (el && typeof el == 'string') {
          ref = ref.orderBy(el)
        } else if (el && typeof el != 'string') {
          ref = ref.orderBy(el.key, el.mod)
        } else {
          ref = ref.orderBy(this.$db.FieldPath.documentId(), 'desc')
        }
      }

      // LIMIT
      ref = ref.limit(limit)

      // Grava Referencia e register para paginação
      if (!state.observers[register]) { 
        state.observers[register] = {} 
      }

      state.observers[register].ref = ref
      state.observers[register].tenantId = tenantId
      state.observers[register].gpEmpresa = gpEmpresa
      state.observers[register].filial = filial
      state.observers[register].collection = collection
      state.observers[register].register = register
      state.observers[register].details = details
      state.observers[register].orderBy = orderBy
      state.observers[register].filters = filters
      state.observers[register].filtersSaller = integration?.filtersSaller
      state.observers[register].filtersClient = integration?.filtersClient
      state.observers[register].limit = limit
      state.observers[register].forceFilter = forceFilter
     
      // SNAPSHOT
      // console.info('observer', collection, register, filters, details, orderBy, limit, ref)
      const objMonitor = {
        origin: 'Ionic',
        function: 'Observer',
        collection, 
        register,
        filters,
        orderBy,
        limit,
        ref,
        forceFilter
      }
      const registerSnapshot = ref.onSnapshot(snapshot => dispatch('processregister', { snapshot, collection, register, details, orderBy, objMonitor, notUnshift }))
     
      // Grava listener para encerramento posterior
      if (state.observers[register].snapshots && state.observers[register].snapshots.length > 0) { 
        state.observers[register].snapshots.push(registerSnapshot) 
      } else { 
        state.observers[register].snapshots = [registerSnapshot] 
      }

      state.observers[register].snapshots = state.observers[register].snapshots

    },
    async nextObserver({ state, dispatch }, { register }) {
      const tenantId = state.observers[register].tenantId
      const gpEmpresa = state.observers[register].gpEmpresa
      const filial = state.observers[register].filial
      const collection = state.observers[register].collection
      const details = state.observers[register].details
      const orderBy = state.observers[register].orderBy
      const filters = state.observers[register].filters
      const filtersSaller = state.observers[register].filtersSaller
      const filtersClient = state.observers[register].filtersClient
      const limit = state.observers[register].limit
      const forceFilter = state.observers[register].forceFilter
      const lastDocCursor = state.observers[register].lastDocCursor

      const ref = await dispatch('prepareRef', { tenantId, gpEmpresa, filial, collection, register, filters, filtersSaller, filtersClient, orderBy, limit, forceFilter })

      if (!lastDocCursor) { return }

      let startAfter = ''
      if (lastDocCursor.length == 1) {
        startAfter = lastDocCursor[0]
      } else {
        for (const el of lastDocCursor) {
          startAfter += `'${el}', `
        }
        startAfter = startAfter.slice(0, -2)
      }

      ref.startAfter(startAfter)
        .onSnapshot(snapshot => {
          const objMonitor = {
            origin: 'Ionic',
            function: 'nextObserver',
            collection, 
            register,
            orderBy,
            ref,
          }          
          dispatch('processregister', { snapshot, collection, register, details, orderBy, objMonitor })
        })
    },
    async processregister({ state, commit, dispatch }, { snapshot, collection, register, details, orderBy, objMonitor, notUnshift = false }) {
      dispatch('snapshotMonitor', {snapshot, obj: objMonitor})

      const changes = snapshot.docChanges()
      const registers = []
      const size = state.registers[register].length
      for (const [idx, el] of changes.entries()) {
        const data = { id: el.doc.id, ...el.doc.data() }
        registers.push(data)
        if (el.type == 'added' || el.type == 'modified') {
          // O firebase sempre busca um item no banco caso haja uma deleção para manter a quantidade de itens solicitadas na query. Esse novo item substituto com newIndex 29.
          // Para evitar que esse item entre no topo da fila sempre que o newIndex não for 29 e já tiver itens no array faremos um push na fila, obrigando o item substituto entrar no final como esperado.
          // Quando estivermos mandando uma carga de pesquisa do mongo usaremos o notUnshift para forçar o push
          commit('setRegister', { register, data, unshift: (size > 0 && el.newIndex < 24 && !notUnshift) ? true : false })
        }
        else if (el.type == 'removed') { 
          commit('removeRegister', { register, data })
        }
      }

      // GET Detalhes em outras collections baseada nos registros encontrados
      if (details) {
        registers.forEach(register => {
          details.forEach(detail => {
            dispatch('getDetails', { item: state.$_.cloneDeep(register), detail: state.$_.cloneDeep(detail) })
          });
        });
      }

      // Grava último id para próxima iteração
      const last = snapshot.docs[snapshot.docs.length - 1];
      let lastDocCursor = null
      if (snapshot.docs.length > 0) {
        let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
        lastDocCursor = []
        for (const el of order) {
          if (el && typeof el == 'string') {
            lastDocCursor.push(last.data()[el])
          } else if (el && typeof el != 'string' && el.key.includes('.')) {
            const path = el.key.split('.')
            let lastData = last.data()
            for (const p of path) {
              lastData = lastData[p]
            }
            lastDocCursor.push(lastData)
          } else if (el && typeof el != 'string') {
            lastDocCursor.push(last.data()[el.key])
          } else {
            lastDocCursor.push(last.id)
          }
        }
      }
      state.observers[register].lastDocCursor = lastDocCursor
      state.loading[register] = false
    },
    // GET Details
    async getDetails({ dispatch }, { item, detail, endSlice = 1 }) {
      const { collection, register, filters, orderBy } = detail
      let get = true
      // Replace Filters
      filters.forEach(elx => {
        if (typeof elx.value == 'string' && elx.value.includes('res.')) {
          const path = elx.value.split('.')
          path.shift()
          let value = state.$_.cloneDeep(item)
          path.forEach(ely => {
            const newValue = value[ely]
            if (value && Array.isArray(newValue) && newValue.length > 0) value = newValue.filter(x => x).slice(0, endSlice)
            else if (value && typeof newValue == 'string' && newValue) value = [newValue]
            else if (value && typeof newValue == 'boolean') value = newValue
            else if (value && typeof newValue == 'object' && !Array.isArray(newValue) && newValue) value = newValue
            else {
              value = null
              get = false
            }
          });
          elx.value = value
        }
      });
      if (get) dispatch('get', { collection, register, filters, orderBy })
    },

    snapshotMonitor({}, {snapshot, obj}) {
      if (!snapshot.empty) {
        if (snapshot.size > 1000) {
          console.warn(obj, `Model Get ${snapshot.size} Leituras`)
          const subject = `UF Manage - Alerta de leitura: ${snapshot.size} Leituras - ${obj.origin} - ${obj.collection}`
          let message = `<strong>${subject}</strong> <br/><br/>`
          delete obj.ref
          obj.orderby = JSON.stringify(obj.orderby)
          obj.filters = JSON.stringify(obj.filters)
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const el = obj[key];
              message += `<strong>${key}:</strong> ${el}<br/>`
            }
          }
          let data = { 
            recipient: [
              'joao.krabbe@userfunction.com.br',
              'gilson.rodrigues@userfunction.com.br',
              'sidney.sales@userfunction.com.br'
            ],
            subject,
            message,
          }
          this.$api.post(`/mail/send`, data)//.then(res => console.info(res))
        }
      }
    },

    // GET
    async get({ state, commit, dispatch, rootState }, { collection, register = collection, filters, disableIntFilters = false, orderBy, query, limit = 50, ref, setRegister = true, forceFilter, offlineReference = false, customerId = null, resetRegister, forceOrder = false }) {
      const integration = (state.registers.integrations) ? state.registers.integrations.find(x => x.collection === collection) : null
      const user = rootState.auth.user

      // PREPARE ENVIROMENT
      const tenantId = customerId || await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') 
      {
        throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
      }
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const filial = await dispatch('getFilial', collection)
      
      collection = tenantId ? `customers/${tenantId}/${collection}` : collection
      
      if (!ref){
        ref = this.$db().collection(collection)
      }
      
      // FILTERS
      if (filters) ref = await dispatch('mountedFilters', { ref, filters, register, forceFilter, tenantId})
      if (integration && !disableIntFilters) {
        let { filtersSaller, filtersClient } = integration
        if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersClient), register, forceFilter, tenantId, userLogged: user })
        else if (filtersSaller) ref = await dispatch('mountedFilters', { ref, filters: JSON.parse(filtersSaller), register, forceFilter, tenantId, userLogged: user })
      }
      
      if (!ref) return

      ref = ref.where('lifeControl.deletedAt', '==', null)
      if (filial) ref = ref.where('filial', '==', filial)
      if (gpEmpresa) ref = ref.where('gpEmpresa', '==', gpEmpresa.slice(0, -1))
      
      // ORDER BY
      if (limit != 1 || forceOrder) {
        let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
        for (const el of order) {
          if (el && typeof el == 'string') {
            ref = ref.orderBy(el)
          } else if (el && typeof el != 'string') {
            ref = ref.orderBy(el.key, el.mod)
          } else {
            ref = ref.orderBy(this.$db.FieldPath.documentId())
          }
        }
      }
      
      // START AT
      if (query) { ref = ref.startAt(filial + query).endAt(`${filial + query}\uf8ff`) }
      
      // LIMIT
      if (limit) ref = ref.limit(limit)
      
      const registerSnapshot = await ref.get()
      
      const obj = {
        origin: 'Ionic',
        function: 'GET',
        collection, 
        register,
        filters,
        orderBy,
        query,
        limit,
        ref,
        setRegister,
        forceFilter,
        customerId
      }
      dispatch('snapshotMonitor', {snapshot: registerSnapshot, obj})
     
      // console.info('get', collection, register, filters, orderBy, query, limit, ref, setRegister, registerSnapshot)

      const registers = []
      if (resetRegister) { commit('resetRegister', register)  }
      registerSnapshot.forEach(doc => {
        const data = { id: doc.id, ...doc.data() }
        registers.push(data)
        if (register && setRegister) commit('setRegister', { register, data })
      });
      if (registers.length === 0 && register && setRegister) {
        commit('resetRegister', register )
      }

      // persiste offline
      if (offlineReference) {
        const { id: idReference, collection: collectionReference, gpEmpresa: geReference } = offlineReference
        const collectionOffline = `${collectionReference}${geReference ? gpEmpresa : ''}`
        const reference = JSON.parse(localStorage.getItem(`offline:${collectionOffline}`))
        const documentReference = reference ? reference[idReference] : null
        if (documentReference) {
          documentReference['dependents'] = {...documentReference['dependents'], [collection]: registers }
          reference[idReference] = documentReference
          localStorage.setItem(`offline:${collectionOffline}`, JSON.stringify(reference))
        }
      }

      return registers    
    },

    // GET BY ID
    async getById({ commit, dispatch }, { collection, register = collection, id, subCollection, orderSubcollection, filtersSubcollection, setRegister = true, getFilial = true, customerId = null }) {
     // PREPARE ENVIROMENT
      const tenantId = customerId || await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') {
        throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
      }
      const gpEmpresa = await dispatch('getGpEmpresa', collection)
      const filial = await dispatch('getFilial', collection)
      if (getFilial) {
        id = gpEmpresa.slice(0, -1) + filial + id
      }

      collection = tenantId ? `customers/${tenantId}/${collection}` : collection
      
      let ref = this.$db().collection(collection).doc(id)

      const doc = await ref.get()
      // console.info('getById', collection, register, id, subCollection, setRegister, doc)
      if (!doc.exists) return
      const data = { id: doc.id, ...doc.data() }

      if (subCollection) {
        const refSub = this.$db().collection(collection).doc(id).collection(subCollection)

        data[subCollection] = await dispatch('get', { ref: refSub, orderBy: orderSubcollection, filters: filtersSubcollection, limit: null, setRegister: false })
      }

      if (register && setRegister) commit('setRegister', { register, data })
      return data
    },

    async sendStack({commit, dispatch}) {
      const stackOffline = JSON.parse(localStorage.getItem('offline:stack'))
      let stackNew = {}

      for (const i in stackOffline) {
        stackNew = {...stackNew, [i]: []}
        for (const stack of stackOffline[i]) {
          const {integration, collection, collectionDetails, item, itemsDetails, gpEmp, fil, gpEmpDetails, filDetails, register, customerId} = stack

          // console.info('i', i);
          // console.info('stackOffline[i]', stackOffline[i]);
          // console.info('stack', stack)
          const isUpdate = item.lifeControl && item.lifeControl.createdAt

          const itemId = item.id
          try {
            if(!isUpdate) delete item.id

            const result = await dispatch('save', {collection, collectionDetails, integration, item, itemsDetails, gpEmp, fil, gpEmpDetails, filDetails, customerId})
            // console.info('result', result);
            if (!isUpdate && result && result.status == 200) {
              commit('removeRegister', { register, data: {id: itemId} })
            }
          } catch (error) {
            console.error(`register: ${register}, collection: ${collection}, id: ${itemId} .::. Error:  ${error}`)
            stackNew[i].push(stack)
          }
        }
      }
      // console.info('stackNew', stackNew);
      localStorage.setItem('offline:stack', JSON.stringify(stackNew))
    },

    // CRUD
    async save({ commit, dispatch, state }, { collection, item, notToast = false, integration = false, collectionDetails, itemsDetails, submitToErp, gpEmp = null, fil = null, gpEmpDetails = null, filDetails = null, updateNotificationToken = false, customerId = null}) {
      const originalCollection = collection
      // caso seja disparado do sendStack (utiliza o customerId, gpEmp, fil, gpEmpDetails, filDetails)
      const tenantId = customerId || await dispatch('getCustomer', collection)
      if (integration) {
        // PREPARE ENVIROMENT
        if (tenantId === null || typeof tenantId === 'undefined') throw new Error('Nenhum ID do Grupo encontrado')
        const gpEmpresa = gpEmp || await dispatch('getGpEmpresa', collection)
        const filial = fil || await dispatch('getFilial', collection)

        item.gpEmpresa = gpEmpresa.slice(0, -1)
        item.filial = filial
        item.errorErp = ''
      }
     
      if (collectionDetails) {
        item[collectionDetails] = itemsDetails.map((x, ix) => {
          return {
            ...x.data,
            gpEmpresa: item.gpEmpresa,
            filial: item.filial
          }
        })
      }
      
      // commit('setLoading', { status: true }, { root: true })
      const method = (item.id) ? 'patch' : 'post'
      let urlMaster = (integration) ? `/integration` : ``
      urlMaster += (item.id) ? `/${collection}/${item.id}` : (item.uid) ? `/${collection}/${item.uid}`: `/${collection}`
     
      return this.$api[method](encodeURI(urlMaster), item, { tenantId })
      .then(async res => {
        const item = res.data.data
     
        if (collectionDetails) {

          // PREPARE ENVIROMENT
          const gpEmpresa = gpEmpDetails || await dispatch('getGpEmpresa', collectionDetails)
          const filial = filDetails || await dispatch('getFilial', collectionDetails)

          const urlDetails = `/integration/batch/${collection}/${collectionDetails}?set=true&clearSubCollections=true`
          itemsDetails = itemsDetails.map((x, ix) => {
            return {
              ...x.data,
              id: res.data.data.id + (ix + 1).toString().padStart(4, '0'),
              idParent: res.data.data.id,
              gpEmpresa: gpEmpresa.slice(0, -1),
              filial
            }
          })
          await this.$api.post(urlDetails, itemsDetails, { tenantId })
        }

        // TODO Alterar para transação
        if (submitToErp) {
          item.submitToErp = true
          item.status = 'Pronto para o envio'
          item.bloqueado = true
          await this.$api.patch(`/integration/${collection}/${item.id}`, item, { tenantId })
        }
        
        if (!notToast) {
          let message = 'Registro Salvo!'

          if (integration) {
            const _integration = state.registers.integrations.find(i => i.collection === originalCollection)
            if ( method == 'patch' && (_integration && _integration.editSuccessMessage)
              || method == 'post'  && (_integration && _integration.registerSuccessMessage) ) {
              try {
                /**
                 * @TODO melhorar a segurança do eval.
                 * está permitindo acesso a todo o escopo do código e a execução de qualquer código,
                 * sendo assim uma falha de segurança.
                 */
                message = method == 'patch' ? eval(_integration.editSuccessMessage) : eval(_integration.registerSuccessMessage)
              } catch (err) {
                console.error('save: Error on eval successMessage', err)
              }
            }
          }
          dispatch('showToast', {message , color: 'success'})
        }

        return res
      })
      .catch(error => { throw (error.response && error.response.data) ? error.response.data.error : error })
      // .finally(() => commit('setLoading', { stats: false }, { root: true }))
    },
    async remove({ commit, dispatch, state }, { collection, item, integration = false }) {
      commit('setLoading', { status: true }, { root: true })
      const tenantId = await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') throw new Error('Nenhum ID do Grupo encontrado')

      const originalCollection = collection
      
      let url = (integration) ? `/integration` : ``
      url += `/${collection}/${item.id}`
      
      if (item.id) {
        return this.$api.delete(url, { tenantId })
          .then(res => {
            let message = 'Registro Deletado!'
            if (integration) {

              const _integration = state.registers.integrations.find(x => x.collection === originalCollection)
              if (_integration.deleteSuccessMessage) {
                try {
                  /**
                   * @TODO melhorar a segurança do eval.
                   * está permitindo acesso a todo o escopo do código e a execução de qualquer código,
                   * sendo assim uma falha de segurança.
                   */
                  message = eval(_integration.deleteSuccessMessage)
                } catch (err) {
                  console.error('save: Error on eval successMessage', err)
                }
              }
            }
            // this.$toast.success(message, { position: 'top-right' })
            dispatch('showToast', {message, color: 'success'})
            return res
          })
          .catch(error => {
            console.error(error)
            return error
          })
          .finally(() => commit('setLoading', { status: false }, { root: true }))
      }
    },

    async generatePDF({ dispatch }, { dataPrint, register }) {
      // const tenantId = await dispatch('getCustomer', 'e')
      const tenantId = await dispatch('getCustomer', register)
      if (tenantId === null || typeof tenantId === 'undefined') throw new Error('Nenhum ID do Grupo encontrado')

      try {
        const { data } = await this.$api.post('/generatepdf', {...dataPrint, pathFilePDF: `${register}/${dataPrint.header?.id || ''}`}, { timeout: 60*1000, noToast: true, tenantId })
        return data
      } catch(error) {
        console.error(error)
        throw error
      }

    },
    
    async calculaImpostos({ dispatch, rootState }, { item, itemsDetails, collectionDetails }) {
      const tenantId = await dispatch('getCustomer', 'SC5')
      if (tenantId === null || typeof tenantId === 'undefined') throw new Error('Nenhum ID do Grupo encontrado')
      if (collectionDetails) {
        const gpEmpresa = await dispatch('getGpEmpresa', collectionDetails)
        const filial = await dispatch('getFilial', collectionDetails)
        // collectionDetails = collectionDetails + gpEmpresa
        item.GPEMPRESA = gpEmpresa.slice(0, -1)
        item.FILIAL = filial
        item[collectionDetails] = []
        for (const x of itemsDetails) { item[collectionDetails].push({ ...x.data, GPEMPRESA: gpEmpresa, FILIAL: filial }) }
      }
      //TODO Arrumar limpeza do item
      delete item.DA0
      delete item.SA1
      delete item.SA3
      delete item.SA4
      delete item.SE4
      delete item._user
      return this.$api.post('/protheus/calculaImpostos', item, { duration: 60*1000, noToast: true, tenantId })
        .then(res => res.data.data)
        .catch(error => error)
    },
    async base64Rascunho({ dispatch, rootState }, { item, itemsDetails, collectionDetails }) {
      // const tenantId = await dispatch('getCustomer', 'e')
      const tenantId = await dispatch('getCustomer', 'SC5')
      if (tenantId === null || typeof tenantId === 'undefined') throw new Error('Nenhum ID do Grupo encontrado')
      if (collectionDetails) {
        const gpEmpresa = await dispatch('getGpEmpresa', collectionDetails)
        const filial = await dispatch('getFilial', collectionDetails)
        item.GPEMPRESA = gpEmpresa.slice(0, -1)
        item.FILIAL = filial
        item[collectionDetails] = []
        for (const x of itemsDetails) { item[collectionDetails].push({ ...x.data, GPEMPRESA: gpEmpresa, FILIAL: filial }) }
      }
      //TODO Arrumar limpeza do item
      delete item.DA0
      delete item.SA1
      delete item.SA3
      delete item.SA4
      delete item.SE4
      delete item._user
      return this.$api.post('/protheus/base64Rascunho', item, { noToast: true, tenantId })
        .then(res => res.data.data)
        .catch(error => {throw error})
    },
    async getDashboardRequest({ dispatch, rootState }, { resource, filters, preFilter, filterExtras }) {
      try {
        const { data } = await this.$api.post('/protheus/request', {resource, filters, preFilter, filterExtras}, { timeout: 60*1000, noToast: true })        
        return data
      } catch (error) {
        console.error(error)
        return error
      }
    },
    removeBundle({ commit }, { collection, itens }) {
      const ids = itens.map(x => x.id)
      commit('setLoading', { status: true }, { root: true })
      if (itens.length > 0) {
        return this.$api.patch(`/${collection}/remove`, ids)
          .then(res => {
            // this.$toast.success('Registros Deletados!', { position: 'top-right' })
            dispatch('showToast', {message, color: 'success'})
            return res
          })
          .catch(error => {
            console.error(error)
            return error
          })
          .finally(() => commit('setLoading', { status: false }, { root: true }))
      }
    },
    async count({ state, commit }, { collection }) {
      const snapshot = this.$db()
        .collection('counts')
        .doc(collection)
        .collection('shards')
        .onSnapshot(snapshot => {
          let count = 0;
          for (const doc of snapshot.docs) {
            count += doc.get('count');
          }
          commit('setCounter', { collection, count })
        })

      // Grava listener para encerramento posterior
      if (state.observers['counts'].snapshots && state.observers['counts'].snapshots.length > 0) { state.observers['counts'].snapshots.push(snapshot) }
      else { state.observers['counts'].snapshots = [snapshot] }
      // store.$set(state.observers['counts'], 'snapshots', state.observers['counts'].snapshots)
      state.observers['counts']['snapshots'] = state.observers['counts'].snapshots
    },
    import({ commit }, { collection, item }) {
      commit('setLoading', { status: true }, { root: true })

      const options = { headers: { 'Content-Type': 'multipart/form-data' } }
      const payload = new FormData();
      for (const key in item) {
        switch (key) {
          case 'file':
            payload.append(key, item[key])
            break;
          default:
            payload.append(key, stringify(item[key]))
            break;
        }
      }

      const method = 'post'
      const url = `/${collection}/import`
      return this.$api[method](url, payload, options)
        .then(res => {
          const { data } = res.data
          // this.$toast.success(data.message, { position: 'top-right' })
          dispatch('showToast', {message, color: 'success'})
          return res
        })
        .catch(error => { throw error.response.data.error || error.response.data })
        .finally(() => commit('setLoading', { status: false }, { root: true }))
    },
    async searchAlgolian({ state, dispatch, rootState }, { index, query, facetFilters = [], restrictSearchableAttributes = [], attributesToRetrieve = ['*'], attributesToHighlight = [], hitsPerPage = 1000 }) {
      const user = rootState.auth.user
      if (state.counters.searchAlgolian > (rootState.algolia.searchLimit)) {
        // this.$toast.error('A consulta não pode ser concluída pois o limite de consultas do algolia já foi alcançado.')
        dispatch('showToast', {message: 'A consulta não pode ser concluída pois o limite de consultas do algolia já foi alcançado.', color: 'danger'})
        return { hits: [] }
      } 

      const compareFilters = (last, actual) => last.length == actual.length && actual.every((arr, idx) => arr.length == last.length && arr.every((str, idx2) => str == last[idx][idx2]))
      if (!rootState.algolia || (state.lastAlgoliaReqParams.query == query && compareFilters(state.lastAlgoliaReqParams.facetFilters, facetFilters))) {
        console.warn('searchAlgolian: prevent searching the same query as last one.')
        return { hits: [] }
      }
      state.lastAlgoliaReqParams = { query, facetFilters }

      // PREPARE ENVIROMENT
      const gpEmpresa = await dispatch('getGpEmpresa', index)
      const filial = await dispatch('getFilial', index)
      const tenantId = await dispatch('getCustomer', index)

      const indexPath = tenantId ? `${tenantId}_${index}` : index

      // FILTERS
      const integration = state.registers.integrations.find(x => x.collection === index)
      if (integration) {
        let { filters, filtersSaller, filtersClient } = integration
       
        let filtersAlgolia = []
        if (filters) { filtersAlgolia = await dispatch('mountedFilters', { filters: JSON.parse(filters), register: index, tenantId, userLogged: user }) }
        if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) { filtersAlgolia = [...filtersAlgolia, ...await dispatch('mountedFilters', { filters: JSON.parse(filtersClient), register: index, tenantId, userLogged: user })] }
        else if (filtersClient) { filtersAlgolia = [...filtersAlgolia, ...await dispatch('mountedFilters', { filters: JSON.parse(filtersSaller), register: index, tenantId, userLogged: user })] }
       
        for (const { key, operator, value } of filtersAlgolia) {
          facetFilters.push([`${key}:${value}`])
        }

        if (filial && !facetFilters.some(ff => 
            ff.some(f => f.includes('filial:'))
          )
        ) {
          facetFilters.push([`filial:${filial}`])
        }

        if (gpEmpresa && !facetFilters.some(ff => 
            ff.some(f => f.includes('gpEmpresa:'))
          )
        ) {
          facetFilters.push([`gpEmpresa:${gpEmpresa.slice(0,-1)}`])
        }

      } else {
        facetFilters.push([`gpEmpresa:${gpEmpresa.slice(0,-1)}`])
        facetFilters.push([`filial:${filial}`])
        console.warn(`searchAlgolian: Couldn't find integration '${index}'.`)
      }
      
      if (!query) {
        facetFilters = facetFilters.filter(ff => ff.some(f => !(f.includes('gpEmpresa:') || f.includes('filial:'))))
      }

      const client = algoliasearch(rootState.algolia.appId, rootState.algolia.searchApiKey);
      const ix = client.initIndex(indexPath);
      return ix.search(query, {
        'facetFilters': facetFilters,
        'restrictSearchableAttributes': restrictSearchableAttributes,
        'attributesToRetrieve': attributesToRetrieve,
        'attributesToHighlight': attributesToHighlight,
        'hitsPerPage': hitsPerPage
      })
        .then(result => {
          // console.info('searchAlgolian', index, indexPath, query, result, facetFilters, restrictSearchableAttributes, attributesToRetrieve, attributesToHighlight, hitsPerPage)
          this.$api.put('/counters/searchAlgolian', {}, {})
            .then(res => res)
            .catch(error => { throw error.response.data.error || error.response.data })
          return { index, indexPath, ...result, filters: facetFilters }
        })
        .catch(e => {
          console.error(e);
          throw e
        })
    },

    // begin offline methods //

    async syncOffline({commit, dispatch, rootState}, {$router}) {
      // console.time('syncOffline')
      commit('setSynchronizing', true, {root: true})
      
      const currentCompany = rootState.companySelected
      for (const company of rootState.companies[currentCompany.groupCompany]['sigamat']) {
        await dispatch('changeCompany', {company, $router}, {root: true})
        
        // Sincroniza tabelas grandes com base no cadastro de integração e registros setados offline
        for (const integration of rootState.integrations) {
          let {inputsMaster} = integration
          const fieldsOffline = inputsMaster ? inputsMaster.filter(i => i.itemsOffline) || []: []
          if (fieldsOffline && fieldsOffline.length > 0) {
            for (const field of fieldsOffline) {
              let nameFilter = null
              let { filters, forceFilter } = field
              const { collection, localStorageCache, filtersOffline, orderOffline:orderBy} = field.itemsOffline
              if (filtersOffline) {
                const { sameOnline, filters: filtersOfflineF, name } = filtersOffline
                filters = sameOnline ? filters : filtersOfflineF
                nameFilter = name
              } else {
                filters = null
              }
              if (collection) {
                await dispatch('cacheOffline', { collection, localStorageCache, filters, forceFilter, nameFilter, orderBy, integration })
              }
            }
          }
        }
        // localStorage.setItem('offline:lastSync', JSON.stringify(lastSync))
      }
      await dispatch('changeCompany', {company: currentCompany, $router}, {root: true})
      commit('setSynchronizing', false, {root: true})
      dispatch('setLastSync', new Date(), {root: true})
      // console.timeEnd('syncOffline')
    },

    // getLastSyncOffline({},{register = null}) {
    //   const lastSync = JSON.parse(localStorage.getItem('offline:lastSync'))
    //   if (lastSync) {
    //     return register ? lastSync[register] : lastSync
    //   }
    //   return null
    // },

    async getOffline({dispatch}, {collection, offlineReference}) {
      // PREPARE ENVIROMENT
      const tenantId = await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') 
      {
        throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
      }

      const { id: idReference, collection: collectionReference } = offlineReference
      const collectionOffline = `customers/${tenantId}/${collectionReference}`

      const reference = JSON.parse(localStorage.getItem(`offline:${collectionOffline}`))
      const documentReference = reference ? reference[idReference] : null

      if (documentReference && documentReference['dependents'] && documentReference['dependents'][collection]) {
        // const gpEmpresa = await dispatch('getGpEmpresa', collection)
        const filial = await dispatch('getFilial', collection)
        if (filial) {
          return documentReference['dependents'][collection].filter(register => register.filial === filial)
        }
        return documentReference['dependents'][collection]
      }

      // mesmo que else
      return []
    },

    async saveOffline({commit, dispatch}, { integration, collection, collectionDetails, item, itemsDetails, register }) {
      // PREPARE ENVIROMENT
      const tenantId = await dispatch('getCustomer', collection)
      if (tenantId === null || typeof tenantId === 'undefined') 
      {
        throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
      }
      const gpEmp = await dispatch('getGpEmpresa', collection)
      const fil = await dispatch('getFilial', collection)

      let stackOffline = JSON.parse(localStorage.getItem('offline:stack'))
      let stackIntegration = stackOffline && stackOffline[collection] ? stackOffline[collection] : []
      
      let gpEmpDetails
      let filDetails

      if (collectionDetails) {
        gpEmpDetails = await dispatch('getGpEmpresa', collectionDetails)
        filDetails = await dispatch('getFilial', collectionDetails)
      }

      item.id = item.id || (new Date()).getTime()

      stackIntegration.push({integration, collection, collectionDetails, item, itemsDetails, gpEmp, fil, gpEmpDetails, filDetails, register, customerId: tenantId})
      stackOffline = {...stackOffline, [collection]: stackIntegration}
      localStorage.setItem('offline:stack', JSON.stringify(stackOffline))
      const registerOff = {...item, status: 'offline', [collectionDetails]: itemsDetails} 
      commit('setRegister', { register, data: registerOff, unshift: true })
    },
    async cacheOffline({commit, dispatch}, {collection, register = collection, subCollection, localStorageCache, filters, filtersSubcollection, orderSubcollection, forceFilter, nameFilter, orderBy, integration}) {
      try {
        // console.time(`cacheOffline - ${register}`)
        // PREPARE ENVIROMENT
        const tenantId = await dispatch('getCustomer', collection)
        if (tenantId === null || typeof tenantId === 'undefined') 
        {
          throw new Error(`Nenhum ID do Grupo encontrado. Collection: ${collection}`)
        }
        const gpEmpresa = await dispatch('getGpEmpresa', collection)
        const filial = await dispatch('getFilial', collection)
        
        const originalCollection = collection
        collection = tenantId ? `customers/${tenantId}/${collection}` : collection

        let refOffline = this.$db().collection(collection)
        refOffline = refOffline.where('lifeControl.deletedAt', '==', null)
      
        // FILTERS
        if (filters) refOffline = await dispatch('mountedFilters', { ref: refOffline, filters, forceFilter, tenantId})
        if (!refOffline) return

        if (filial) refOffline = refOffline.where('filial', '==', filial)
        if (gpEmpresa) refOffline = refOffline.where('gpEmpresa', '==', gpEmpresa.slice(0, -1))

        // ORDER BY
        let order = (Array.isArray(orderBy)) ? orderBy : [orderBy]
        for (const el of order) {
          if (el && typeof el == 'string') {
            refOffline = refOffline.orderBy(el)
          } else if (el && typeof el != 'string') {
            refOffline = refOffline.orderBy(el.key, el.mod)
          } else {
            refOffline = refOffline.orderBy(this.$db.FieldPath.documentId(), 'desc')
          }
        }

        const registerSnapshotOffline = await refOffline.get()
        // console.info('cacheOffline', collection, registerSnapshotOffline)
        
        let registersOffline = {}
        
        registerSnapshotOffline.forEach(async doc => {
          const data = { id: doc.id, ...doc.data() }
          commit('setRegister', { register, data })
          
          const {tableCollection} = integration
          if (tableCollection && tableCollection == originalCollection && data.offline != false) { 
            let {tableSubcollection, filtersSubcollection, orderSubcollection, orderSubcollectionOffline} = integration
            if (orderSubcollectionOffline) orderSubcollection = orderSubcollectionOffline
            if (['{', '['].some(symbol => orderSubcollection.includes(symbol))) { orderSubcollection = JSON.parse(orderSubcollection) }
            if (['{', '['].some(symbol => filtersSubcollection.includes(symbol))) { filtersSubcollection = JSON.parse(filtersSubcollection) }
              // console.time(`cacheOffline - ${tableSubcollection}`)
              await dispatch('getById', {
                collection: tableCollection,
                id: data.id,
                subCollection: tableSubcollection,
                filtersSubcollection, 
                orderSubcollection,
                setRegister: false,
                getFilial: false
              })
              // console.timeEnd(`cacheOffline - ${tableSubcollection}`)
          }

          registersOffline = {...registersOffline, [doc.id]: data}
        });

        if (localStorageCache) {
          localStorage.setItem(`offline:${collection}${nameFilter ? `_${nameFilter}` : ''}`, JSON.stringify(registersOffline))
        }
        // console.timeEnd(`cacheOffline - ${register}`)
        return registersOffline
      } catch(e) {
        console.error(e)
        return null
      }
    },

    // end offline methods //
    
    async post ({}, { url, data = null}) {
      try {
        return await this.$api.post(url, data)
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async getApi({dispatch}, { url, options, generic, timeout = 600000}) {
      try {
        const tenantId = await dispatch('getCustomer', 'e')
        if (generic) {
          url = `/protheus/genericRequest`
          if (options && options.params) 
            options.params = {...options.params, ...generic} 
          else 
            options = {params: generic}
        }

        const result = await this.$api.get(url, {...options, tenantId, timeout})
        return result.data
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async showToast({}, {message, color, duration = 2000, position = 'bottom', animated = true, buttons = []}) {
      const toast = await toastController
        .create({
          message,
          duration,
          color,
          position,
          animated,
          buttons
        })
      await toast.present();
    },

    // GET EXTERNAL REQUEST
    async getExternal({ commit, dispatch, rootState }, { register, query, ordem, idField, id, search, fieldsToSearch, fieldsToMark = [], filters, setRegister = true, page = 1, perPage = 45, nextPage = false, filtersIn = [], allRegs = false, async = false, customerId = null, params={}, completeRes = false, isRestNode = false }) {
      const tenantId = customerId || await dispatch('getCustomer', 'e')
      const gpEmpresa = await dispatch('getGpEmpresa', 'e')
      const filial = await dispatch('getFilial', 'e')
      const user = rootState.auth.user // Disponivel para Filtro
      const searchred = (search && fieldsToSearch && fieldsToSearch.length > 0)
      const filtered = (filters && filters.length > 0)
      const filteredIn = (filtersIn && filtersIn.length > 0 && filtersIn.filter(f => f.selecteds.length > 0))
      const superAdmin = user.superAdmin
      const admin = (user.companies && user.companies[rootState.companySelected.groupCompany]) ? user.companies[rootState.companySelected.groupCompany].admin : false
      if (!allRegs) {
        commit('resetRegister', `${register}FilteredAll`)
        commit('resetRegister', `${register}All`)
      }

      if (!nextPage && !id) {
        commit('resetRegister', `${register}Filtered`)
        commit('setCounter', {counter: `${register}Filtered`, count: 0})
      }
      // if (page == 1 && !async) commit('setLoading', { status: true }, { root: true })

      let querySearch = ''
      if (searchred) {
        querySearch += ' AND ('
        for (const att of fieldsToSearch) {
          querySearch += `UPPER(${att}) LIKE '%${search.toUpperCase()}%' OR `
        }
        querySearch = querySearch.slice(0, -3)+')'
      }
     
      let queryFilter = ''
      if (filtered) {
        for (const values of filters) {
          for (let value of values) {
            if (value && value.includes('IN')) {
              queryFilter += ` AND ${value} `
            }
            if (value && value.includes(':')) {
              value = value.split(':') 
              queryFilter += ` AND ${value[0]} = '${value[1]}'`
            }
            if (value && value.includes('~~')) {
              value = value.split('~~') 
              const values = value[1].split(',')
              queryFilter += ` AND ${value[0]} BETWEEN '${values[0]}' AND '${values[1]}'`
            }
          }
        }
      }
      
      let queryFilteredIn = ''
      if (filteredIn) {
        const queryFiltersIn = filtersIn.map((f, index) => {
          const {field, selecteds, orAnd = 'AND'} = f
          const values = selecteds && selecteds.length > 0 ? selecteds.map(s => `'${(s+'').split('<em>').join('').split('</em>').join('')}'`).join(",") : "''"
          if (typeof field === 'string')
            return  `${field} IN (${values}) `
          else 
            return `(${field.map(f => `${f} IN (${values})`).join(` ${orAnd} `)})`
        }).join(' AND ')
        queryFilteredIn += ` AND ${queryFiltersIn} `
      }

      if (query.includes('${')){ 
        const clearQueryFilter = query.includes('queryFilter')
       
        if (!query.includes('`')) { query = "`"+query+"`" }
        const queryEval = eval(query)
       
        if (clearQueryFilter) { queryFilter = '' }
        if (typeof queryEval === 'string') { 
          query = queryEval + querySearch + queryFilter + queryFilteredIn
        } else if (typeof queryEval === 'function') { 
          query = queryEval({querySearch, queryFilter, queryFilteredIn, user})
        }
      } else if (query.includes('`')) {
        query = eval(query) + querySearch + queryFilter + queryFilteredIn
      }

      if (id) query = `SELECT * FROM (${query}) AS SQL WHERE ${idField} = '${id}' `
      
      if (async) {
        try {
          const res = await this.$api.post('/protheus?path=RESTQRY', {
            "PAGINA": page,
            "PORPAGINA": allRegs ? 99999999999 : perPage,
            "QUERY": query,
            "ORDEM": ordem
          }, {noToast: false, tenantId, isRestNode })
          if (!res || !res.data || !res.data) return []
          let {PROXIMO, TOTAL, RETORNOS} = res.data
          if (register && setRegister) {
            commit('setCounter', {counter: (searchred || filtered || filteredIn) ? `${register}Filtered` : register, count: TOTAL})
  
            for (const el of RETORNOS) {
              el.id = el[idField]
              if (searchred) {
                for (const att of fieldsToSearch) {
                  if (el[att]) {
                    el[att] = el[att].replace(search.toUpperCase(), `<em>${search.toUpperCase()}</em>`)
                  } else {
                    const fieldMarked = fieldsToMark.find(fm => fm.searchableContent === att)
                    if (fieldMarked)
                    el[att] = el[fieldMarked.value].replace(search.toUpperCase(), `<em>${search.toUpperCase()}</em>`)
                  }
                }
              }
  
              commit('setRegister', { register: (searchred || filtered || filteredIn) ? `${register}Filtered${allRegs?'All':''}` : `${register}${allRegs?'All':''}`, data: el })
            }
          }
          RETORNOS = this.$_.cloneDeep(RETORNOS)
          return (completeRes) ? res.data : (id) ? RETORNOS[0] : RETORNOS
        } catch (error) {
          if (error?.response?.status) {
            console.error('error', error.response.status, error.response.data.error)  
          } else {
            console.error('error', error)  
          }
          return error
        }
      } else {
        // console.info(register, ordem, idField, id, search, fieldsToSearch, filters, setRegister, page, perPage, nextPage, query)
        return this.$api.post('/protheus?path=RESTQRY', {
          "PAGINA": page,
          "PORPAGINA": allRegs ? 99999999999 : perPage,
          "QUERY": query,
          "ORDEM": ordem
        }, {noToast: false, tenantId, isRestNode})
        .then(res => {
          if (!res || !res.data || !res.data) return []
          let {PROXIMO, TOTAL, RETORNOS} = res.data
          if (register && setRegister) {
            commit('setCounter', {counter: (searchred || filtered || filteredIn) ? `${register}Filtered` : register, count: TOTAL})
  
            for (const el of RETORNOS) {
              el.id = el[idField]
              if (searchred) {
                for (const att of fieldsToSearch) {
                  if (el[att]) {
                    el[att] = el[att].replace(search.toUpperCase(), `<em>${search.toUpperCase()}</em>`)
                  } else {
                    const fieldMarked = fieldsToMark.find(fm => fm.searchableContent === att)
                    if (fieldMarked) el[fieldMarked.value] = el[fieldMarked.value].replace(search.toUpperCase(), `<em>${search.toUpperCase()}</em>`)
                  }
                }
              }
  
              commit('setRegister', { register: (searchred || filtered || filteredIn) ? `${register}Filtered${allRegs?'All':''}` : `${register}${allRegs?'All':''}`, data: el })
            }
          }
          
          RETORNOS = this.$_.cloneDeep(RETORNOS)
          return (id) ? RETORNOS[0] : RETORNOS
        })
        .catch(error => {
          if (error?.response?.status) {
            console.error('error', error.response.status, error.response.data.error)  
          } else {
            console.error('error', error)  
          }
          return error
        })
        .finally(() => commit('setLoading', {register, status: false}, {root: true}))
      }
    },
    async getOnMongo({state, commit, dispatch, rootState}, payload){
      let {register, collection, subCollection, idParent, id, filters, orFilters, andOrFilters, dateRange, fields, orderBy, getTotal, limit, getDeleteds, startAfter, resetRegister = false, onSnapshot = false, forceFilter = true, getFirestore = false, notMounted = false, distinct, disableIntFilters = false} = payload
      const originalRegister = register.replace('Filtered', '')
      // PREPARE ENVIROMENT
      const tenantId = await dispatch('getCustomer', 'e')
      let gpEmpresa = await dispatch('getGpEmpresa', subCollection || collection)
      gpEmpresa = gpEmpresa.slice(0, -1)
      const filial = await dispatch('getFilial', subCollection || collection)
      if (!idParent && subCollection) idParent = gpEmpresa+filial+id
      
      if (resetRegister) { commit('resetRegister', register)  }
      if (!startAfter) { getTotal = true}

      // FILTERS
      if (filters) {
        filters = filters.map(x => {
          let filter = Array.isArray(x) ? x[0] : null
          let operator = ''
          
          if (filter && filter.includes('like')) {
            filter = filter.split('like') 
            operator = 'like'
          }
          if (filter && filter.includes(':')) {
            filter = filter.split(':') 
            operator = '=='
          }
          if (filter && filter.includes('~~')) {
            filter = filter.split('~~') 
            operator = '~~'
          }
          if (filter && filter.includes('~')) {
            filter = filter.split('~') 
            operator = '~'
          }
          if (filter && filter.includes('!=')) {
            filter = filter.split('!=') 
            operator = '!='
          }
          if (filter && filter.includes('>')) {
            filter = filter.split('>') 
            operator = '>'
          }
          if (filter && filter.includes('>=')) {
            filter = filter.split('>=') 
            operator = '>='
          }
          if (filter && filter.includes('<')) {
            filter = filter.split('<') 
            operator = '<'
          }
          if (filter && filter.includes('<=')) {
            filter = filter.split('<=') 
            operator = '<='
          }
          if (filter && filter.length > 1) {
            x = {
              key: filter[0],
              operator,
              value: filter[1]
            }
          }
          return x
        })
      } else {
        filters = []
      }
      if (!startAfter) { getTotal = true}

      const user = rootState.auth.user
      const integration = (state.registers.integrations) ? state.registers.integrations.find(x => x.collection === (subCollection || collection)) : null
      if (integration && !disableIntFilters) {
        let { filters:_filters, filtersSaller, filtersClient } = integration

        if (_filters) { _filters = await dispatch('mountedFilters', { filters: JSON.parse(_filters), register, tenantId, userLogged: user }) } else { _filters = [] }

        if (filtersClient && user?.companies && user?.companies[tenantId]?.A1_COD?.trim()) {
          filtersClient = await dispatch('mountedFilters', { filters: JSON.parse(filtersClient), register, tenantId, userLogged: user })
        } else { filtersClient = [] }
        
        if (filtersSaller) {
          filtersSaller = await dispatch('mountedFilters', { filters: JSON.parse(filtersSaller), register, tenantId, userLogged: user }) 
        } else {
          filtersSaller = []
        }
        if (_filters) filters = [...filters, ..._filters]
        if (filtersClient) filters = [...filters, ...filtersClient]
        if (filtersSaller) filters = [...filters, ...filtersSaller]
      } else if (filters && !notMounted) {
        filters = await dispatch('mountedFilters', { filters, register, tenantId, userLogged: user })
      }

      if (onSnapshot || getFirestore) { 
        if (!fields) fields = []
        fields.push('idFirestore')
      }
      return this.$api.get(`/mongodb/${(subCollection) ? `${collection}.${subCollection}` : collection}`, {
        tenantId,
        noToast: true,
        params: {
          gpEmpresa: gpEmpresa,
          filial,
          idParent,
          filters: JSON.stringify(filters),
          orFilters: JSON.stringify(orFilters),
          andOrFilters: JSON.stringify(andOrFilters),
          dateRange: JSON.stringify(dateRange),
          fields: JSON.stringify(fields),
          orderBy: (typeof orderBy != 'string') ? JSON.stringify(orderBy) : orderBy,
          getTotal,
          limit,
          getDeleteds,
          startAfter,
          distinct
        }
      })
      .then(async res => {
        if (res.status == 200) {
          const {meta, data} = res.data
          if (onSnapshot || getFirestore) {
            if (getFirestore) res.data.data = []
            // Em tempo real
            const ids = data.map(x => x.id)
            if (ids && ids.length > 0) {
              const chunks = []
              for (let ix = 0; ix < ids.length/10; ix++) {
                chunks.push(ids.slice(ix*10, (ix+1)*10))
              }
              for (const el of chunks) {
                if (onSnapshot) {
                  await dispatch(
                    'observer', 
                    {
                      collection, 
                      register, 
                      filters: [{
                        key: this.$db.FieldPath.documentId(), 
                        operator: 'in', 
                        value: el
                      }],
                      limit: el.length,
                      disableIntFilters: true,
                      notUnshift: true,
                      forceFilter
                    }
                  )
                } else if (getFirestore) {
                  const regs = await dispatch(
                    'get', 
                    {
                      collection: (subCollection && idParent) ? `${collection}/${idParent}/${subCollection}` : collection, 
                      register, 
                      filters: [{
                        key: this.$db.FieldPath.documentId(), 
                        operator: 'in', 
                        value: el
                      }],
                      limit: el.length,
                      disableIntFilters: true,
                      forceFilter,
                      resetRegister
                    }
                  )
                  for (const reg of regs) {
                    const ix = res.data.data.findIndex(x => x.id === reg.id)
                    if (ix > -1) {
                      res.data.data[ix] = reg
                    } else {
                      res.data.data.push(reg)
                    }
                  }
                }
                // desabilida o reset após a primeira pagina
                resetRegister = false
              }
            }

            if (getFirestore) {
              res.data.data = res.data.data.sort((a, b) => {
                if (!Array.isArray(orderBy)) { orderBy = [orderBy] }
                
                for (const el of orderBy) {
                  let field = el.field || el.key
                  let mod = 1
                  if (field) {
                    mod = (el.mod && (el.mod.toLowerCase() == 'desc' || el.mod == -1)) ? -1 : 1
                  } else {
                    field = el
                  } 
                  if (!field) { return 0 }
                  if (a[field] < b[field]) return -1*mod
                  if (a[field] > b[field]) return 1*mod
                  continue
                }
                return 0
              })
            }
          } else {
            // Estatico
            for (const el of data) {
              commit('setRegister', { register, data:el })
              if (register.includes('Filtered')) { commit('setRegister', { register: originalRegister, data:el }) }
            }
          }

          // Referencias para paginação
          if (!state.mongodb[register]) {
            state.mongodb[register] = {}
          }
          state.mongodb[register].payload = payload
          if (meta && meta.lastDocCursor) {
            state.mongodb[register].lastDocCursor = meta.lastDocCursor
          } else {
            state.mongodb[register].lastDocCursor = null
          }
        }
      
        return res
      })
      .then(res => (res.status == 200) ? res.data : null)
      .catch(err => {
        state.mongodb[register].lastDocCursor = null
        return err
      })
      .finally(() => {
        // console.timeEnd(`getOnMongo - ${collection}`)
        // console.info('getOnMongo', collection, subCollection, originalRegister, register, idParent, filters, orFilters, dateRange, fields, orderBy, getTotal, limit, getDeleteds, startAfter, onSnapshot, getFirestore)
      })
    },
    async nextOnMongo({ state, dispatch }, { register, limit }) {
      const lastDocCursor = state.mongodb[register].lastDocCursor
      if (!lastDocCursor) { return }
      const payload = state.mongodb[register].payload
      if (limit) payload.limit = limit
      payload.resetRegister = false
      return await dispatch('getOnMongo', {...payload, getTotal: false, startAfter: lastDocCursor})
    }
  }
}

export default register